import React, { useEffect } from 'react'

import { Tabs } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import PropTypes from 'prop-types'

import ensureMTCaptcha from 'Utils/ensureMTCaptcha'

import UserLogin from './Login'
import UserRegister from './Register'

function UserTabs({
  activeTabId = '', customId = '', source = '', captchaId = '', loadScripts = false, locale = 'en',
}) {
  useEffect(() => {
    if (!loadScripts) {
      return undefined
    }

    const cleanup = ensureMTCaptcha()

    return cleanup
  }, [loadScripts])

  const loginTab = {
    title: 'Log in',
    id: 'login',
    expand: true,
    contents: <UserLogin customId={customId} captchaId={captchaId} locale={locale} />,
  }
  const registerTab = {
    title: 'Register',
    id: 'register',
    expand: true,
    contents: <UserRegister customId={customId} source={source} captchaId={captchaId} locale={locale} />,
  }

  return (
    <Tabs
      className="auth-tabs"
      expand
      activeTabId={activeTabId || ''}
      tabs={[
        loginTab,
        registerTab,
      ]}
    />
  )
}

UserTabs.propTypes = {
  activeTabId: PropTypes.string,
  customId: PropTypes.string,
  source: PropTypes.string,
  captchaId: PropTypes.string,
  loadScripts: PropTypes.bool,
  locale: PropTypes.string,
}

export default UserTabs
